/**
 * ChunkReloadRestore — renders nothing, restores route after chunk recovery reload.
 *
 * Place inside Router, near the top of your app shell:
 *   <BrowserRouter>
 *     <ChunkReloadRestore />
 *     <AppProvider>
 *       <App />
 *     </AppProvider>
 *   </BrowserRouter>
 *
 * Safe: validates target is internal, clears storage, replaces history entry
 * so back button doesn't go to /?_v=...
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CHUNK_TARGET_KEY, isSafeInternalTarget } from '../utils/chunkRecoveryPolicy';

export function ChunkReloadRestore() {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const target = sessionStorage.getItem(CHUNK_TARGET_KEY);
      if (!target || !isSafeInternalTarget(target)) return;

      // Clear immediately so it only fires once
      sessionStorage.removeItem(CHUNK_TARGET_KEY);

      // Replace so back button doesn't go to "/?_v=..."
      console.log(`[ChunkRecovery] Restoring route: ${target}`);
      navigate(target, { replace: true });
    } catch {
      // ignore — user will land on default route via RootRedirect
    }
  }, [navigate]);

  return null;
}
